import React from "react";
import CourseProgramCards from "../../Home/CourseProgramCards";

const BusinessAdministrationPrograms = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2072&q=80",
    heading: "Business Management",
    introduction: "Learn fundamental business management principles and practices.",
    buttonText: "LEARN MORE",
    route: "business-management",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2072&q=80",
    heading: "Marketing Management",
    introduction: "Develop marketing strategies and customer relationship skills.",
    buttonText: "LEARN MORE",
    route: "marketing-management",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2072&q=80",
    heading: "Financial Management",
    introduction: "Master financial planning, budgeting, and investment strategies.",
    buttonText: "LEARN MORE",
    route: "financial-management",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2072&q=80",
    heading: "Human Resource Management",
    introduction: "Learn HR practices, recruitment, and employee development.",
    buttonText: "LEARN MORE",
    route: "human-resource-management",
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2072&q=80",
    heading: "Operations Management",
    introduction: "Optimize business operations and supply chain management.",
    buttonText: "LEARN MORE",
    route: "operations-management",
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2072&q=80",
    heading: "Strategic Planning",
    introduction: "Develop strategic thinking and business planning skills.",
    buttonText: "LEARN MORE",
    route: "strategic-planning",
  },
];

const BusinessAdministrationProgramsCard = () => {
  return (
    <div className="flex justify-center space-x-0">
      <CourseProgramCards
        programs={BusinessAdministrationPrograms}
        basePath="/courses/business-administration"
      />
    </div>
  );
};

export default BusinessAdministrationProgramsCard;
